/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useState, useEffect, useCallback} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "components/elements/main/index.scss";

import * as Actions from "actions";

import UserTryoutHistory from "components/widgets/user/UserTryoutHistory";
import {isLocalMarket, isMarketPlace} from "helpers/utils";

const UserProductsTryouts = (props) => {

    const {
        match, userMainResetSearchProducts, bootupInfo, includeHeader
    } = props;

    const marketId = (isLocalMarket() ? bootupInfo.appState.subdomain_marketId : "");

    const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

  const [state] = useState({
    layoutColumns: 3,
  });

    useEffect(() => {
    document.getElementById("color").setAttribute("href", "#");
  }, []);

  return (
      <UserTryoutHistory includeHeader={includeHeader} {...props} shopId={shopId} colSize={state.layoutColumns} />
  );
};

UserProductsTryouts.propTypes = {
    userMainResetSearchProducts: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userProductsTryouts = connect(
  ({ userMainProducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainProducts.reqStatus,
    isLoading: userMainProducts.isLoading,
    serviceError: userMainProducts.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserProductsTryouts);

export default userProductsTryouts;
